import { render, staticRenderFns } from "./MyOrderDetails.vue?vue&type=template&id=6bcc9a06&scoped=true&"
import script from "./myorderdetails.js?vue&type=script&lang=js&"
export * from "./myorderdetails.js?vue&type=script&lang=js&"
import style0 from "./MyOrderDetails.vue?vue&type=style&index=0&id=6bcc9a06&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6bcc9a06",
  null
  
)

export default component.exports